var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header",on:{"click":function($event){return _vm.headerClick()}}},[_c('img',{staticClass:"bg-grid",attrs:{"src":require("../assets/headercota.svg"),"alt":"Cota.80.86 - Arqueologia"}})])}
var staticRenderFns = []

export { render, staticRenderFns }